import { useState } from 'react';
import SimpleDialog from '../../../../features/common/SimpleDialog';
import { Account } from '../../../../stores/AccountStore';
import AccountImportStepOne from './AccountImportStepOne';
import useAccountImport from './hooks/AccountImport.hooks';
import StandardButton from '../../../components/Button/StandardButton';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import Box from '@mui/material/Box';
import FallbackSpinner from '../../../../materio/@core/components/spinner';
import AccountDataGrid from './AccountDataGrid';
import SectionAppBar from '../../../components/Section/SectionAppBar';
import CloseButton from '../../../components/Button/CloseButton';

type AccountImportProps = {
    onContinue: (accounts: Account[]) => void;
};

const AccountImport = ({ onContinue }: AccountImportProps) => {
    const { open, accounts, onClose, hasUnmappedRequired, loaded, loadAccounts, currentStep, setCurrentStep } =
        useAccountImport();
    const [loading, setLoading] = useState(false);

    const handleNext = async () => {
        setLoading(true);
        try {
            await loadAccounts();
            setCurrentStep(2);
        } catch {
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <SimpleDialog open={open} onClose={onClose}>
                <FallbackSpinner />
            </SimpleDialog>
        );
    }

    const handleClose = () => {
        onContinue(accounts);
        onClose();
    };

    return (
        <SimpleDialog open={open} onClose={handleClose} padding={0}>
            <Box display="flex" flexDirection="column" height="100%">
                <Box flexGrow={1}>
                    {currentStep === 1 && <AccountImportStepOne />}
                    {currentStep === 2 && <AccountDataGrid onClose={handleClose} />}
                </Box>
                {currentStep === 1 && (
                    <Box padding={2} display="flex" width="100%" justifyContent="flex-end">
                        <StandardButton
                            onClick={handleNext}
                            icon={<NavigateNextIcon />}
                            sx={{ marginTop: 'auto', alignSelf: 'flex-end' }}
                            disabled={hasUnmappedRequired || !loaded}
                        >
                            Next
                        </StandardButton>
                    </Box>
                )}
            </Box>
        </SimpleDialog>
    );
};

export default AccountImport;
